import { render, staticRenderFns } from "./GroupItems.vue?vue&type=template&id=6a9d664b&scoped=true"
import script from "./GroupItems.vue?vue&type=script&lang=js"
export * from "./GroupItems.vue?vue&type=script&lang=js"
import style0 from "./GroupItems.vue?vue&type=style&index=0&id=6a9d664b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d664b",
  null
  
)

export default component.exports